export default __webpack_public_path__ + "static/URWDIN-Regular-e9bbcfa2da20f22583a5ff0eb0333b3d.ttf";